import { Button, Spinner } from 'avo-ui'
import { BannerSalePageContainer } from '../../../containers/main-page/sale-page/banner-sale-page/BannerSalePageContainer'
import { VoucherHighlightContainer } from '../../../containers/main-page/sale-page/voucher-highlight/VoucherHighlightContainer'
import { ProductHighlightContainer } from '../../../containers/main-page/sale-page/product-highlight/ProductHighlightContainer'

export const SalePage = ({ sectionProps, isLoadingUpload, isLoading, isUpdating, onSubmit }) => {
    return (
        <div className={'flex flex-col space-y-3 px-9 py-4'}>
            {isLoading ? (
                <Spinner className={'w-8 h-8 my-10 mx-auto !border-blue-50'} />
            ) : (
                <>
                    <div className={'flex flex-col space-y-6'}>
                        <BannerSalePageContainer {...sectionProps} />
                        <VoucherHighlightContainer {...sectionProps} />
                        <ProductHighlightContainer {...sectionProps} />
                    </div>
                    <div className={'flex py-3 justify-center'}>
                        <Button
                            className={'w-[200px]'}
                            loading={isLoadingUpload || isUpdating}
                            title={'Submit'}
                            onClick={onSubmit}
                        />
                    </div>
                </>
            )}
        </div>
    )
}
